import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { MaterialModule } from './material.module';
import { FiltersComponent } from './filters/filters.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { AlertsComponent } from './alerts/alerts.component';
import { CadastreComponent } from './cadastre/cadastre.component';
import { CronogramaComponent } from './dialog-cronograma/cronograma/cronograma.component';
import { TransactionItemComponent } from './transaction-item/transaction-item.component';
import { TransactionItemAdminComponent } from './transaction-item-admin/transaction-item-admin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogCronogramaComponent } from './dialog-cronograma/dialog-cronograma.component';
import {
  DialogSideListDialog,
  SideListComponent,
} from './side-list/side-list.component';
import { SpinnerComponent } from 'src/app/shared/spinner/spinner.component';
import { MultiLanguagePipe } from 'src/app/core/pipes/multi-language.pipe';
import { MultiLanguageComplexPipe } from 'src/app/core/pipes/multi-language-complex.pipe';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OrderByPipe } from '../core/pipes/order.pipe';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { DialogPossibleWitnessesComponent } from './dialog-possible-witnesses/dialog-possible-witnesses.component'
import { GridPagerComponent } from '../core/components/grid-pager/grid-pager.component';
import { MultiLangPipe } from '../core/pipes/multi-lang.pipe';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { DateMaskDirective } from './directives/date-mask.directive';

@NgModule({
  declarations: [
    MultiLanguagePipe,
    MultiLanguageComplexPipe,
    FiltersComponent,
    NotificationsComponent,
    AlertsComponent,
    MultiLanguagePipe,
    MultiLanguageComplexPipe,
    SpinnerComponent,
    CadastreComponent,
    CronogramaComponent,
    TransactionItemComponent,
    TransactionItemAdminComponent,
    DialogCronogramaComponent,
    DialogSideListDialog,
    SideListComponent,
    OrderByPipe,
    DialogPossibleWitnessesComponent,
    GridPagerComponent,
    MultiLangPipe,
    BreadcrumbComponent,
    DateMaskDirective
  ],
  exports: [
    MaterialModule,
    CommonModule,
    FiltersComponent,
    NotificationsComponent,
    AlertsComponent,
    MultiLanguagePipe,
    MultiLanguageComplexPipe,
    SpinnerComponent,
    CadastreComponent,
    CronogramaComponent,
    TransactionItemComponent,
    TransactionItemAdminComponent,
    DialogCronogramaComponent,
    DialogSideListDialog,
    SideListComponent,
    OrderByPipe,
    DialogPossibleWitnessesComponent,
    GridPagerComponent,
    MultiLangPipe,
    BreadcrumbComponent,
    DateMaskDirective
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonModule,
    RouterModule,
    NgxMaskModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: rootLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
})
export class SharedModule {}

export function rootLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/main/', '.json');
}
